/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */

// CSS
import 'angular-material/angular-material.scss';
import '../styles/index.scss';
import 'nvd3/build/nv.d3.min.css';
import 'angular-material-data-table/dist/md-data-table.css';
import 'leaflet/dist/leaflet.css';
import 'ng-material-datetimepicker/dist/material-datetimepicker.min.css';

// Application
import { Configuration } from './Configuration';
import { State } from './model/State';
import { HttpInterceptorFactory } from './util/HttpInterceptor';
import { XsrfInterceptorFactory } from './util/XsrfInterceptor';
import { IsArrayFilterFactory } from './filter/IsArrayFilter';
import { NotFilterFactory } from './filter/NotFilter';
import { TruncateFilterFactory } from './filter/TruncateFilter';
import { OrderByLocaleCompareFactory } from './filter/OrderByLocaleCompare';
import './module/util/UtilModule';
import './module/security/SecurityModule';
import './module/organization/OrganizationModule';
import './module/prevention/PreventionModule';
import './module/equipment/EquipmentModule';
import './module/alarm/AlarmModule';
import './module/actionrequest/ActionRequestModule';
import './module/statistics/StatisticsModule';
import './module/exports/ExportsModule';

angular.module('serfimtic.gmao', [
    'ui.router',
    'pascalprecht.translate',
    'ngMaterial',
    'angularMoment',
    'ngCookies',
    'md.data.table',
    'angularLoad',
    'nemLogging',
    'dndLists',
    'LocalStorageModule',
    'ui-leaflet',
    'file-model',
    'nvd3',
    'ngMaterialDatePicker',
    'serfimtic.gmao.util',
    'serfimtic.gmao.security',
    'serfimtic.gmao.organization',
    'serfimtic.gmao.prevention',
    'serfimtic.gmao.equipment',
    'serfimtic.gmao.alarm',
    'serfimtic.gmao.actionrequest',
    'serfimtic.gmao.statistics',
    'serfimtic.gmao.exports'
])
.config(($logProvider, configuration) => {
    /** @ngInject */
    // Enables logging message in the browser's $log.
    $logProvider.debugEnabled(configuration.DEBUG);
})
.config($locationProvider => {
    /** @ngInject */
    // Tries to use HTML5 history component for URLs, if supported. Use anchors as a fallback.
    $locationProvider.html5Mode(true).hashPrefix('!');
})
.config($urlRouterProvider => {
    /** @ngInject */
    // When the path doesn't match an existing state's path, then redirect to the login path.
    $urlRouterProvider.otherwise('/login');
})
.config($httpProvider => {
    /** @ngInject */
    // Interceptors are executed with a LIFO order: the last interceptor appended will be the first one called.
    $httpProvider.interceptors.push(HttpInterceptorFactory);
    $httpProvider.interceptors.push(XsrfInterceptorFactory);
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
})
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractComponentState('gmao', 'gmaoViewport'))
        .state(State.componentState('gmao.notfound', 'notFound', '/notfound', 'ui.notfound.title'));
})
.config(($translateProvider, configuration) => {
    /** @ngInject */
    $translateProvider.translations('fr', require('../translations/fr.json'))
    $translateProvider.useSanitizeValueStrategy('escape');
    $translateProvider.preferredLanguage(configuration.LANG);
    $translateProvider.fallbackLanguage(configuration.LANG);
})
.config(($mdDateLocaleProvider, dateTimeServiceProvider, configuration) => {
    /** @ngInject */
    $mdDateLocaleProvider.formatDate = dateObj => {
        return (dateObj) ? dateTimeServiceProvider.$get().formatLocalDate(dateObj, configuration.DATE_FORMAT) : '';
    };
    $mdDateLocaleProvider.parseDate = dateStr => {
        const dateArr = dateStr.split('-');
        return (dateStr) ? new Date(Date.UTC(dateArr[2], dateArr[1] - 1, dateArr[0])) : '';}
})
.config($mdThemingProvider => {
    /** @ngInject */
    $mdThemingProvider.theme('angular-material-gmao');
})
.config(localStorageServiceProvider => {
    /** @ngInject */
    localStorageServiceProvider.setPrefix('sertimtic-gmao');
})
.constant('configuration', Configuration)
.filter('isArray', IsArrayFilterFactory)
.filter('not', NotFilterFactory)
.filter('truncate', TruncateFilterFactory)
.filter('orderByLocaleCompare', OrderByLocaleCompareFactory)
.run(($rootScope, $log, $transitions, $state, $translate, $q, navigationService) => {
    /** @ngInject */

    // Handles page title, using state's custom parameter 'title'.
    $transitions.onSuccess({}, transition => {
        $log.debug(`Transition from '${transition.from().name}' to '${transition.to().name}'`);
        $translate('ui.title').then(translation => {
            let promise;
            if (angular.isUndefined(transition.to().title)) {
                promise = translation;
            } else {
                promise = $translate(transition.to().title).then(
                    stateTranslation => stateTranslation + ' - ' + translation
                ).catch(() => $log.error(`Missing translation: [${transition.to().title}]`));
            }
            return promise;
        }).then(title => {
            $rootScope.title = title;
        });
    });

    // Overwrite the builtin default error handler, so as it uses the $log service, which can be hidden if debug is
    // disabled (production mode).
    $state.defaultErrorHandler(error => {
        $log.error('Transition error');
        $log.error(error);
    });

    $transitions.onError({}, transition => {
        if (angular.isNumber(transition.error().status) && (transition.error().status === 404)) {
            $state.go('gmao.notfound');
        }
    });

    $log.info('GMAO is up');
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/GmaoModule.js